import { EntityModel } from 'src/core/services/data/models';
import { DataService, property } from "src/core/services/data.service";
import { BookemZulu as Model } from 'src/core/services/data/JayDataContext';
import { computed } from "mobx";
import { IsNotEmpty, IsPositive, Max, ValidateIf, IsDefined, Validate, ValidateNested, Min, IsNumber } from 'class-validator';
import { RuleValidation } from 'src/core/customValidator/ruleValidator';


export class RulesDataService extends DataService<typeof Model.Rules.Logic.ViewModels.RuleItem, Model.Rules.Logic.ViewModels.RuleItem, RuleItem> {
	protected map(entity: Model.Rules.Logic.ViewModels.RuleItem): RuleItemModel {
		return new RuleItemModel(entity);
	}

	public static make(ctx?: any): RulesDataService {
		return new RulesDataService(ctx, ctx => ctx.Rules);
	}

	public add() {
		const entity = new Model.Rules.Logic.ViewModels.RuleItem();
		(entity as any).dynamicProperties = {
			conditions: [],
			alternativeExecutors: [],
			branchExecutors: [],
			policy: 'All'
		};
		
		return entity;
	}
}

export class RuleItemModel extends EntityModel<Model.Rules.Logic.ViewModels.RuleItem, RuleItem> implements RuleItem {

	@property<RuleItemModel>(o => o.entity.id, (o, value) => o.entity.id = value)
	public id: number;

	@property<RuleItemModel>(o => o.entity.name, (o, value) => o.entity.name = value)
	@IsDefined({
		message: "The rule name must not be empty"
	})
	public name: string;

	@property<RuleItemModel>(o => o.entity.eventName, (o, value) => o.entity.eventName = value)
	@IsDefined({
		message: "The rule watch event must not be empty. Sure to select an event to watch"
	})
	public eventName: string;

	@property<RuleItemModel>(o => o.entity.eventTypeFullName, (o, value) => o.entity.eventTypeFullName = value)
	@IsDefined({
		message: "The rule watch event must not be empty. Sure to select an event to watch"
	})
	public eventTypeFullName: string;

	@property<any>(o => o.entity.dynamicProperties, (o, value) => o.entity.dynamicProperties = value)
	@Validate(RuleValidation)
	public dynamicProperties: {};

	@property<RuleItemModel>(o => o.entity.isActive, (o, value) => o.entity.isActive = value)
	public isActive: boolean;

	@property<RuleItemModel>(o => o.entity.description, (o, value) => o.entity.description = value)
	public description: string;
	
	@property<RuleItemModel>(o => o.entity.mode, (o, value) => o.entity.mode = value)
	@IsDefined({ message: 'Execution mode is empty' })
	public mode: number;


	@property<RuleItemModel>(o => o.entity.executionDeadline, (o, value) => o.entity.executionDeadline = value)
	@ValidateIf((o, val) => o.mode == 'Scheduled')
	@IsDefined({ message: 'Execution date is empty' })
	public executionDeadline: Date;

	

	@property<RuleItemModel>(o => o.entity.executionTimeSpan, (o, value) => o.entity.executionTimeSpan = value)
	@ValidateIf((o, val) => o.mode == 'Recurrent')
	@IsDefined({ message: 'Execution quartz script is empty' })
	public executionTimeSpan: string;

	
	@property<RuleItemModel>(o => o.entity.eventWrapperName, (o, value) => o.entity.eventWrapperName = value)
	public eventWrapperName: string;

	@property<RuleItemModel>(o => o.entity.eventDescription, (o, value) => o.entity.eventDescription = value)
	public eventDescription: string;
	
}



// WEBPACK FOOTER //
// ./src/app/rules/rules/form/rules-form.data.ts